document.addEventListener('click', async function (e) {
    const btnModalEditarMaquina = e.target.closest('#btnModalEditarMaquina');
    if (!btnModalEditarMaquina) return;

    const idMaquina   = btnModalEditarMaquina.getAttribute("data-id");
    const formEditar  = document.querySelector("#formEditarMaquina");
    const modalEditar = document.querySelector("#ModalEditarMaquina");

    if (!formEditar || !idMaquina || !modalEditar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para editar la máquina.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/maquinas/infoMaquina?idMaquina=${idMaquina}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información de la máquina.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEditar.classList.add('modal--show');

        const inputIdMaquina   = formEditar.querySelector('#idMaquinaEditar');
        const inputCodigo      = formEditar.querySelector('#codigoMaquinaEditarDisplay');
        const inputNombre      = formEditar.querySelector('#nombreMaquinaEditarDisplay');
        const inputDesc        = formEditar.querySelector('[name="descripcionMaquina"]');
        const selectZona       = formEditar.querySelector('[name="idZonaTrabajo"]');
        const divShitch        = formEditar.querySelector('#divShitchMaquina');

        if (inputIdMaquina) inputIdMaquina.value = data.idMaquina          || "";
        if (inputCodigo)    inputCodigo.value    = data.codigoMaquina      || "";
        if (inputNombre)    inputNombre.value    = data.nombreMaquina      || "";
        if (inputDesc)      inputDesc.value      = data.descripcionMaquina || "";
        if (selectZona)     selectZona.value     = data.idZonaTrabajo      || "";

        const checked     = Number(data.estadoMaquina) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estadoMaquina) === 1 ? 'ACTIVA' : 'INACTIVA';

        divShitch.innerHTML = `
            <span class="labelInfo">Estado:</span>
            <label class="switchEstado">
                <input
                    id="estado"
                    type="checkbox"
                    name="estadoMaquina"
                    value="${data.estadoMaquina}"
                    ${checked}
                >
                <span class="sliderEstado"></span>
                <span class="textoEstado">${textoEstado}</span>
            </label>
        `;

    } catch (error) {
        console.error("Error al obtener información de la máquina:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información de la máquina.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarMaquina') {
        e.preventDefault();
        const formulario = e.target;
        const btnSubmit  = formulario.querySelector('#btnEditarMaquina');
        const spinner    = formulario.querySelector('#spinner');
        const formData   = new FormData(formulario);
        if (!formulario || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para editar la máquina.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/maquinas/editar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1500);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Máquina editada correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
